import { Component, OnInit } from '@angular/core';
import { ContentService } from '../../shared/content.service';

@Component({
  selector: 'app-att',
  templateUrl: './att.component.html',
  styleUrls: ['./att.component.scss']
})
export class AttComponent implements OnInit {

  page: Object;
  
  constructor(private contentService: ContentService) { 
  }

  ngOnInit() {
    this.page = this.contentService.pages['att'];
  }

}
